import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useMap } from "react-leaflet";
import MySwitch from "../../../../atoms/MySwitch";

type Props = {
  showCharts: boolean;
  onShowChartsChange: (checked: boolean) => void;
  showPins: boolean;
  onShowPinsChange: (checked: boolean) => void;
};

export const ChartViewSettings = ({
  showCharts,
  onShowChartsChange,
  showPins,
  onShowPinsChange,
}: Props): JSX.Element | null => {
  const map = useMap();
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const corner = map
      .getContainer()
      .querySelector(".leaflet-bottom.leaflet-left") as HTMLElement | null;
    if (!corner) return;
    const div = document.createElement("div");
    div.className = "leaflet-control chart-others-back chart-others-settings";
    corner.appendChild(div);
    setContainer(div);
    return () => {
      div.remove();
      setContainer(null);
    };
  }, [map]);

  if (!container) return null;

  return ReactDOM.createPortal(
    <div className="chart-view-setting">
      <MySwitch initialValue={showCharts} title="グラフ" changed={onShowChartsChange} />
      <MySwitch initialValue={showPins} title="ピン" changed={onShowPinsChange} />
    </div>,
    container,
  ) as JSX.Element;
};
